"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {},
    hiddenInputLabel: {
      color: theme.colors.greySoft,
      fontWeight: 400
    },
    formControl: {
      textAlign: 'right'
    },
    inputsControl: {
      display: 'block'
    },
    isFullWidth: {
      '& $formControl': {
        width: '100% !important',
        flex: 1
      }
    },
    vertical: {
      '& $formControl': {
        width: '290px'
      }
    },
    horizontal: {
      '& $formControl': {
        width: '460px'
      }
    },
    hidden: {
      display: 'none'
    }
  };
};

exports.default = _default;